import React, { PureComponent } from 'react'

import { grant, grantAdmin } from '../Utils/Service'

class InstructorDetails extends PureComponent {
  render () {
    const i = this.props.instructor
    return (
      <ul className="row-item">
        <li>
          <span>Nome</span>
          {i.name}
        </li>
        <li>
          <span>Email</span>
          {i.email}
        </li>
        <li className="info-buttons">
          {
            grant() && (
              <button className="lnk-edits" onClick={() => this.props.showEdit(i)}><i className="fas fa-edit"></i></button>
            )
          }
          {
            grantAdmin() && (
              <button className="lnk-edits" onClick={() => this.props.showDelete(i)}><i className="fas fa-trash-alt"></i></button>
            )
          }
        </li>
      </ul>
    )
  }
}

export default InstructorDetails



// WEBPACK FOOTER //
// ./src/components/Instructors/InstructorDetails.js